












import {Vue, Component} from 'vue-property-decorator';
import mainToolbar from '../toolbar/toolbar.vue';
import mainProjects from './projects/projects.vue';

@Component({
  components: {
    mainToolbar,
    mainProjects,
  },
})
export default class Main extends Vue {
  private mounted() {
    this.$message({
      message: 'Website under construction. More content will be added soon :)',
      type: 'warning',
      duration: 5000,
    });
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/main/main.vue